import HundredBricksAPIError from '../../../HundredBricksAPIError';
class InvestorCoupons extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('InvestorCouponsError', ...args);
    }
}
export default InvestorCoupons;
